
import { defineComponent } from '@vue/composition-api';
import {
  multiOmicsForm, addAwardDoi, templateHasData, checkJGITemplates,
} from '../store';
import { HARMONIZER_TEMPLATES } from '@/views/SubmissionPortal/types';
import Definitions from '@/definitions';
import SubmissionContextShippingForm from './SubmissionContextShippingForm.vue';

export default defineComponent({
  components: {
    SubmissionContextShippingForm,

  },
  props: {
    label: {
      type: String,
      default: 'Data generated ',
    },
  },

  setup() {
    const doiRequiredRules = () => [(v: string) => {
      const valid = !!v || (!multiOmicsForm.facilityGenerated && multiOmicsForm.dataGenerated) || (multiOmicsForm.unknownDoi && !multiOmicsForm.dataGenerated);
      return valid || 'An award DOI is required if data was or is going to be generated by a DOE facility.';
    }];

    function facilityChange() {
      if (multiOmicsForm.awardDois === null || multiOmicsForm.awardDois.length < multiOmicsForm.facilities.length) {
        addAwardDoi();
      }
      // @ts-ignore
      this.$emit('revalidate');
    }

    return {
      facilityChange,
      Definitions,
      doiRequiredRules,
      multiOmicsForm,
      templateHasData,
      checkJGITemplates,
      HARMONIZER_TEMPLATES,
    };
  },

});
